import * as z from "zod/v4";

export const putMasonhubIntegration = {
  name: "putMasonhubIntegration" as const,
  input: z.object({
    apiToken: z.string().optional(),
    accountSlug: z.string(),
    sandboxMode: z.boolean(),
    createReturns: z.boolean(),
  }),
  output: z.object({}),
};
